import jquery from 'jquery';
import EventBus from '@/event-bus';
import Search from '@/search';
import Template from '@/template';
import _Singleton from '@/tools/singleton';

/** @private */
var FIRST_ITEM = 0;
/**
 * Связка с DOM для поиска
 * @memberof Search
 * @alias ui
 * @class
 *
 * @private
 */
var SearchDOM = function () {
  var self = this;


  document.addEventListener("DOMContentLoaded", function () {
    Search.settings.inProcess = 'inProcess';
    self._init()
  });
};

/**
 * Инициализация
 * @private
 */
SearchDOM.prototype._init = function () {
  var self = this;

  self._setConfig();
  self._keyUp();
  self._events();
  self._outFocus();
};

/**
 * Грузим настройки по готовности DOM
 * @private
 */
SearchDOM.prototype._setConfig = function () {
  var self = this;

  self.$searchField = jquery('[' + Search.settings.searchSelector + ']');
  self.$searchForm = self.$searchField.parents('form:first');

  self.$searchField.attr(Search.settings.inProcess, false);
};

/**
 * Получаем форму, с которой работаем
 * @private
 * @param {Object} $object - jQuery-нода
 */
SearchDOM.prototype._getInstance = function ($object) {
  var $search = null;
  var _target = $object.data('target');

  if (_target) {
    $search = jquery(_target);
  }
  else {
    $search = $object.parents('form:first');
  }

  return $search;
};

/**
 * Обработчик ввода символов
 * @private
 */
SearchDOM.prototype._keyUp = function () {
  var self = this;

  jquery(document).on('keyup', '[' + Search.settings.searchSelector + ']', function () {
    var $input = jquery(this);
    var $form = self._getInstance($input);
    var _query = $input.val();
    var _inProcess = $input.prop(Search.settings.inProcess);

    document._searchActive = true;

    // блокировка ввода
    if (_inProcess) {
      return;
    }

    if ($input[FIRST_ITEM]._queryLength == _query.length) {
      return;
    }

    $input[FIRST_ITEM]._queryLength = _query.length;
    $input.prop(Search.settings.inProcess, true);

    Search._get({
      query: _query,
      input: $input,
      form: $form
    });
  });
};

/**
 * Вешаем слушателя на обновление данных из поиска
 * @private
 */
SearchDOM.prototype._events = function () {
  EventBus.subscribe('update:insales:search', function (eventData) {
    var $node = null;

    if (eventData.action.form) {
      // срабатывает на события внутри формы
      $node = eventData.action.form
        .find('[' + Search.settings.resultPlaceholder + ']');
    }
    else {
      // убиваем потраха во всех формах
      $node = jquery('[' + Search.settings.resultPlaceholder + ']');
    }

    $node.html(Template.render(eventData, Search.settings.template));

    document._searchActive = false;

    // если указан инпут, который надо разлочить
    if (eventData.action.input) {
      eventData.action.input
        .prop(Search.settings.inProcess, false)
        .trigger('keyup');
    }
  });
};

/**
 * Перехватываем клик вне поиска
 * @private
 */
SearchDOM.prototype._outFocus = function () {
  jquery(document).on('click', function (event) {
    var $input = jquery('[' + Search.settings.searchSelector + ']');
    var $form = $input.parents('form:first');

    if (document._searchActive && !jquery(event.target).closest($form).length) {
      Search._get({
        query: '',
        input: $input,
        form: $form
       });
    }
  });
};

export default _Singleton(SearchDOM).getInstance();
